module.exports = require("mocha");


//////////////////
// WEBPACK FOOTER
// external "mocha"
// module id = 1222
// module chunks = 0